import { useMemo } from 'react';
import { Card, Container } from 'reactstrap';

import TabControl from '../../components/tabs/TabControl';
import { PathsLayouts } from '../../config/routes';
import { TranslationsKeys } from '../../locales/translations';
import ElectiveRequirementsTab from './parts/ElectiveRequirementsTab';

export default function GraduationRequirementsReview() {
  const tabs = useMemo(
    () => [
      {
        name: 'graduate',
        content: (
          <ElectiveRequirementsTab
            enrollmentStatus="egresado"
            readOnly={false}
            hideStatusFilter={false}
          />
        ),
      },
      {
        name: 'titled',
        content: (
          <ElectiveRequirementsTab
            enrollmentStatus="titulado"
            readOnly={true}
            hideStatusFilter={true}
          />
        ),
      },
    ],
    [],
  );

  return (
    <Container fluid>
      <Card>
        <TabControl
          translationNs={TranslationsKeys.GRADUATION_REQUIREMENTS_REVIEW}
          tabsPrefix="tabs"
          tabs={tabs}
          path={PathsLayouts.graduationRequirementsReview}
        />
      </Card>
    </Container>
  );
}
